import { useRef, useEffect, RefObject } from "react";

type UseOverflowDetectorResult = {
  contentWrapperRef: RefObject<HTMLDivElement>;
  contentInsideWrapperRef: RefObject<HTMLDivElement>;
};

export function useOverflowDetector(
  content: React.ReactNode,
  onHasOverflow: (hasOverflow: boolean) => void,
): UseOverflowDetectorResult {
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const contentInsideWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const contentWrapper = contentWrapperRef.current;
    const contentInsideWrapper = contentInsideWrapperRef.current;

    if (!contentWrapper || !contentInsideWrapper) return;

    const checkOverflow = () => {
      const isOverflowing =
        contentInsideWrapper.scrollHeight > contentWrapper.clientHeight;

      if (isOverflowing) onHasOverflow(isOverflowing);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(contentWrapper);
    resizeObserver.observe(contentInsideWrapper);

    return () => resizeObserver.disconnect();
  }, [content]);

  return { contentWrapperRef, contentInsideWrapperRef };
}
